module.exports = "/assets/landing-cf/instagram/insta-feed-5.jpg?QbLjWRs";